_collow.components.BoxStepPage = class BoxStepPage extends (
    _collow.components.Base
  ) {
    root;
    elements;
    params;
    allBoxes;
    currentStepName;
    currentStepNumber;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.allBoxes = document.querySelectorAll(`.box`);

      this.allBoxes.forEach(box => box.addEventListener('click', this.marksBoxAsClicked));
    }

    marksBoxAsClicked = (e) => {
      const boxClicked = e.target.closest('.box')
      this.currentStepNumber = document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1];
      this.currentStepName = document.querySelector(`.content-section[active="true"]`).getAttribute("step-name");
      const boxesCurrentStep = document.querySelectorAll(`.box[step=${this.currentStepName}]`);
      const optionSelected = boxClicked.getAttribute("option")
      
      boxesCurrentStep.forEach(box => box.removeAttribute("clicked"))
      boxClicked.setAttribute("clicked", true)

      this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: true, data: optionSelected, label: boxClicked.getAttribute("label")});
    }
};
  
   
  
  
  
  
  
  